enum FilterPopoverTab {
  Locations,
  Placements,
}

export default FilterPopoverTab;
